import { ReadiedRoute, Redirect } from "@itandi/tools/next";
import type { NextPage } from "next";
import { NskHead } from "~/components/common/head/NskHead";
import { Page as Component } from "~/components/specifics/deals/[id]/estimations/ocr_requests/[requestId]/Page";

export const PATH = (dealId: number, requestId: number): string =>
	`/deals/${dealId}/estimations/ocr_requests/${requestId}`;

function DealEstimationOcrRequestPage() {
	return (
		<ReadiedRoute fallback={<Redirect url="/" />}>
			<NskHead title="見積書のAI読み取り" />
			<Component />
		</ReadiedRoute>
	);
}

export default DealEstimationOcrRequestPage as NextPage;
